// extracted by mini-css-extract-plugin
export var aircallIframe = "_ms-3";
export var fabContainer = "_ms-5";
export var fabRinging = "_ms-6";
export var loadingOverlay = "_ms-4";
export var pulse = "_ms-7";
export var widgetContent = "_ms-2";
export var widgetPanel = "_ms-0";
export var widgetPanelExpanded = "_ms-1";